<template>
  <div class="card card-comp width-card modern-card">
    <div class="row">
      <div class="col-2 align-self-center">
        <span class="badge ml-2" :class="cssStatus">{{ status ? 'Online' : 'Offline' }}</span>
      </div>
      <div class="col-10">
        <div class="card-body-signal">
          <div class="card-top">
            <span class="paragraph-15-weight300 pl-1">{{ text }}</span>
            <!-- Se não houver valor válido, mostra 'Sem sinal' com estilo neutro -->
            <span v-if="hasValue" class="fontSize15 card-value pr-1" :class="colorClass">{{ value | formatNumberZero }} dBm</span>
            <span v-else class="fontSize15 card-value pr-1 no-signal">Sem sinal</span>
          </div>

          <div class="date-update">
            Data da ultima atualização:
            <span v-if="date" class="card-value pr-1">{{ date | formatDateTime }}</span>
          </div>

          <!-- Barra de progresso inspirada em CardUsage -->
          <div class="progress-bar">
            <div
              class="progress-fill"
              :class="[colorClass, { 'no-signal': !hasValue }]"
              :style="{ width: percent + '%' }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardSignal',
  props: ['text', 'value', 'status', 'date'],
  computed: {
    // indica se existe um valor numérico válido
    hasValue() {
      return this.value !== null && this.value !== undefined && this.value !== '' && !Number.isNaN(Number(this.value));
    },
    cssStatus() {
      return {
        'badge-success': this.status,
        'badge-danger': !this.status,
      };
    },
    // converte dBm (negativo) em percentual para a barra — aproximado: -50dBm ~= 100%, -100dBm ~= 0%
    percent() {
      if (!this.hasValue) return 0;
      const abs = Math.abs(Number(this.value) || 0);
      // fórmula: (100 - abs) * 2, então abs=50 -> 100%, abs=100 -> 0%
      let p = (100 - abs) * 2;
      if (p > 100) p = 100;
      if (p < 0) p = 0;
      return Math.round(p);
    },
    colorClass() {
      // quando não houver valor, usar classe neutra
      if (!this.hasValue) return 'no-signal';
      const p = this.percent;
      if (p > -1 && p < 26) return 'color-green';
      if (p >= 26 && p < 51) return 'color-yellow';
      if (p >= 51 && p < 76) return 'color-orange';
      if (p >= 76) return 'color-red';
      return '';
    }
  }
};
</script>

<style scoped>
/* Modern card base (inspirado em CardUsage) */
.card-comp {
  margin-left: -15px;
  margin-top: 14px;
  margin-bottom: 0px;
  border-radius: 0.2rem;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
  border: 1px solid #e6e6e6;
  background-color: #fff;
}

.modern-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

.card-body-signal {
  padding: 0.75rem 0.9rem;
}

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.date-update {
  font-size: 11px;
  margin-left: 0.25rem;
  color: #4c4c4c;
}

/* Barra de progresso */
.progress-bar {
  height: 6px;
  background-color: #f1f1f1;
  border-radius: 3px;
  overflow: hidden;
  margin-top: 0.6rem;
}

.progress-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.5s ease-out;
  width: 0%;
}

/* Classes de cores para texto e barra (mesmas do CardUsage) */
.color-green {
  color: #009933;
}
.progress-fill.color-green {
  background-color: #009933;
}

.color-yellow {
  color: #ffcc00;
}
.progress-fill.color-yellow {
  background-color: #ffcc00;
}

.color-orange {
  color: #ff6600;
}
.progress-fill.color-orange {
  background-color: #ff6600;
}

.color-red {
  color: #db2511;
}
.progress-fill.color-red {
  background-color: #db2511;
}

/* nova classe para estado sem sinal */
.no-signal {
  color: #7a7a7a;
}
.progress-fill.no-signal {
  background-color: #cfcfcf;
}

/* pequenas correções de estilo já existentes */
.icon-status {
  font-size: 1.8rem;
  font-weight: 700;
}

.icon-signal-online {
  color: #27ae60;
}

.icon-signal-offline {
  color: #e74c3c;
}
</style>
